import { render, staticRenderFns } from "./OnlineCultureArt.vue?vue&type=template&id=1e219918&"
import script from "./OnlineCultureArt.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureArt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports